/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import returnDateText from "../../helpers/ReturnDateText";

import RelatedImage from "../../assets/images/static/related__cards.png";
import ReladtedIcon from "../../assets/images/icons/realted__cardIcon.png";

const RelatedPackages = ({ allPackages, packages }) => {
  const [category, setCategory] = useState(null);
  const [relatedPackages, setRelatedPackages] = useState([]);

  const { t } = useTranslation();

  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  };

  const searchRelated = () => {
    if (category !== null) {
      const related = allPackages.filter((item) => item.category === category);

      if (related.length >= 2) {
        let num1 = getRandomInt(0, related.length);
        let num2 = getRandomInt(0, related.length);

        if (num1 === num2) {
          num2 = getRandomInt(0, related.length - 1);
          setRelatedPackages([related[num1], related[num2]]);
        } else {
          setRelatedPackages([related[num1], related[num2]]);
        }
      } else {
        setRelatedPackages(related);
      }
    }
  };

  useEffect(() => {
    searchRelated();
  }, [allPackages, category]);

  useEffect(() => {
    packages?.category && setCategory(packages.category);
  }, [packages]);

  return (
    <div className="related">
      <div className="related__title">
        <p>Paquetes</p>
        <h2>RELACIONADOS</h2>
      </div>

      <div className="related__container">
        {relatedPackages.length &&
          relatedPackages.map((item, index) => (
            <Link
              to={`${t("routes.psportsdetails")}/${item.title
                .replace(/ /g, "-")
                .toLowerCase()}/${item.id}`}
              key={index}
              className={`related__item ${index > 0 ? "item2" : ""}`}
            >
              <img src={item.image ? item.image : RelatedImage} alt="image" />

              <div className={`related__item-info ${index > 0 ? "info2" : ""}`}>
                <h3>{returnDateText(item.date).monthName}</h3>

                <p>{item.title}</p>

                <small>{item.description}</small>

                <div
                  className={`related__footer ${index > 0 ? "footer2" : ""}`}
                >
                  <img src={ReladtedIcon} alt="icon" />
                </div>
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
};

export default RelatedPackages;
